import type { Language } from "./site";

/** Approved brand slogan. Reuse verbatim wherever the slogan is displayed. */
export const BRAND_TAGLINE: Record<Language, string> = {
  ar: "الإبتكار عندنا بديهي - مش اختيار",
  en: "Innovation is second nature to us—not a choice.",
};
